export default __webpack_public_path__ + "static/media/metamask2.cdd19319.png";